import React from 'react';

import { Skeleton } from '@mui/material';
import PropTypes from 'prop-types';

const DEFAULT_ROWS_AMOUNT = 1;

const ProgramsSkeletonLoader = ({ rowsAmount = DEFAULT_ROWS_AMOUNT }) =>
  Array.from({ length: rowsAmount }, (_, index) => (
    <Skeleton height={100} key={index} variant="rounded" />
  ));

ProgramsSkeletonLoader.propTypes = {
  rowsAmount: PropTypes.number,
};

export default ProgramsSkeletonLoader;
